import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const History = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <defs>
      <path
        id="history-a"
        d="M12.667 5.333a6.666 6.666 0 110 13.334.667.667 0 110-1.334 5.333 5.333 0 10-5.331-5.5L7.333 12v.39l.862-.861a.667.667 0 01.88-.056l.063.056c.24.24.259.618.056.88l-.056.062-2 2-.017.017a.67.67 0 01-.045.038l.062-.055a.67.67 0 01-.471.196h-.013a.67.67 0 01-.04-.002l.053.002a.671.671 0 01-.409-.14l-.014-.011a.67.67 0 01-.036-.033l-.013-.012-2-2a.667.667 0 01.88-.998l.063.056.862.861V12a6.666 6.666 0 016.667-6.667zm0 3.334c.342 0 .623.257.662.589l.004.077v2h2c.342 0 .624.258.663.59L16 12a.667.667 0 01-.589.662l-.078.005h-2.666a.667.667 0 01-.663-.59L12 12V9.333c0-.368.298-.666.667-.666z"
      ></path>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="history-b" fill="#fff">
        <use xlinkHref="#history-a"></use>
      </mask>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#history-a"></use>
      <g fill={props.color || theme.palette.grey600} mask="url(#history-b)">
        <path d="M0 0h24v24H0z"></path>
      </g>
    </g>
  </svg>
);
